import { withI18n } from '@lingui/react'
import { bool, node, string } from 'prop-types'
import { compose } from 'redux'

import { TOOLTIP_SIDES, TOOLTIP_TYPES } from 'shared/consts/tooltip'
import { ODS_PDP_MODAL, ODS_PDP_TOOLTIP } from 'shared/experiments/consts'
import { PDP_ODS_MODAL_BOX_OPEN } from 'shared/experiments/consts/events'
import IconCross from 'views/components/atoms/Icon/IconCross'
import IconOds from 'views/components/atoms/Icon/IconOds'
import Modal from 'views/components/molecules/Modal'
import ModalShowButton from 'views/components/molecules/ModalShowButton'
import TextWithIcon from 'views/components/molecules/TextWithIcon'
import Tooltip from 'views/components/molecules/Tooltip'
import Experiment from 'views/components/utils/optimizely/Experiment'
import Track from 'views/components/utils/optimizely/Track'
import Variant from 'views/components/utils/optimizely/Variant'
import withMountPoints from 'views/enhancers/withMountPoints'
import { i18nType, mountPointsType } from 'views/utils/propTypes'

import { ODS_MODAL_ID } from './consts'
import OdsModalContent from './OdsModalContent'
import OdsModalContentVC from './OdsModalContentVC'

import './OdsZavaModal.scss'

const BuyBoxOdsButtonAndModal = ({
  i18n,
  odsLabel,
  videoConsultation,
  indicationUrl,
  hideIcon,
}) => {
  const modalTitle = videoConsultation ? (
    <Experiment name={ODS_PDP_MODAL}>
      <Variant name={'default'}>
        {() => i18n._('pdp.buyboxwithvariants.odsModal.title')}
      </Variant>
      <Variant name={'v1'}>
        {() => i18n._('pdp.buyboxwithvariants.odsModalVC.title')}
      </Variant>
    </Experiment>
  ) : (
    i18n._('pdp.buyboxwithvariants.odsModal.title')
  )

  const buttonTextODS = videoConsultation ? (
    <Experiment name={ODS_PDP_MODAL}>
      <Variant name={'default'}>
        {() => i18n._('buyBox.link.label.onlineDoctorService')}
      </Variant>
      <Variant name={'v1'}>
        {() => i18n._('buyBox.link.label.onlineDoctorService.zava')}
      </Variant>
    </Experiment>
  ) : (
    odsLabel
  )

  const textComponent = hideIcon ? (
    <span className="a-h3 u-font-weight--normal u-no-margin">
      {buttonTextODS}
    </span>
  ) : (
    <TextWithIcon icon={<IconOds sizeSmallTiny="small" />} inline>
      <span className="a-h3 u-font-weight--normal">{buttonTextODS}</span>
    </TextWithIcon>
  )

  const modalType = videoConsultation ? (
    <Experiment name={ODS_PDP_MODAL} preventActivation>
      <Variant name={'default'}>
        {() => (
          <Track event={PDP_ODS_MODAL_BOX_OPEN} data={{ tag: 'default' }}>
            <OdsModalContent indicationUrl={indicationUrl} />
          </Track>
        )}
      </Variant>
      <Variant name={'v1'}>
        {() => (
          <Track event={PDP_ODS_MODAL_BOX_OPEN} data={{ tag: 'v1' }}>
            <OdsModalContentVC />
          </Track>
        )}
      </Variant>
    </Experiment>
  ) : (
    <OdsModalContent indicationUrl={indicationUrl} />
  )

  const modalShowButtonBasic = (
    <ModalShowButton
      style="buttonGhost"
      id="odsModalButton"
      name="buybox-large_online-doctor-service"
      className="a-Button__buy-box-ods"
      data-clientside-hook="ods-modal-trigger-button"
      modalId={ODS_MODAL_ID}
      title={i18n._('buyBox.link.label.onlineDoctorService')}
    >
      {textComponent}
    </ModalShowButton>
  )

  const modalShowButtonWithTooltip = (
    <Tooltip
      id={'buybox-ods-tooltip'}
      fullWidth
      isOnlyVisibleInView
      text={i18n._('buyBox.link.label.onlineDoctorService.tooltip')}
      type={TOOLTIP_TYPES.RX_GREEN}
      sideRendered={TOOLTIP_SIDES.BOTTOM}
      icon={<IconCross />}
      isVisible
    >
      {modalShowButtonBasic}
    </Tooltip>
  )

  const modalShowButton = videoConsultation ? (
    <Experiment name={ODS_PDP_MODAL}>
      <Variant name={'default'}>{() => modalShowButtonBasic}</Variant>
      <Variant name={'v1'}>
        {() => (
          <Experiment name={ODS_PDP_TOOLTIP}>
            <Variant name={'default'}>{() => modalShowButtonBasic}</Variant>
            <Variant name={'v1'}>{() => modalShowButtonWithTooltip}</Variant>
          </Experiment>
        )}
      </Variant>
    </Experiment>
  ) : (
    modalShowButtonBasic
  )

  return (
    <div>
      <Modal id={ODS_MODAL_ID} size="medium" title={modalTitle}>
        {modalType}
      </Modal>

      {modalShowButton}
    </div>
  )
}

BuyBoxOdsButtonAndModal.propTypes = {
  i18n: i18nType.isRequired,
  videoConsultation: bool.isRequired,
  indicationUrl: string,
  mountPoints: mountPointsType.isRequired,
  odsLabel: node.isRequired,
  hideIcon: bool,
}

BuyBoxOdsButtonAndModal.defaultProps = {
  hideIcon: false,
  videoConsultation: false,
}

export default compose(withI18n(), withMountPoints)(BuyBoxOdsButtonAndModal)
